// This is a fork of https://github.com/mui/mui-x/blob/v7.23.6/packages/x-data-grid/src/components/columnsManagement/utils.ts
// Note: Can't import the utils file from MUI without errors
// There is no code changes done in this file besides the imports.
// forked from package version: 7.23.6

import type {
  GridColumnVisibilityModel,
  GridColumnsManagementProps,
} from '@mui/x-data-grid';

export const checkColumnVisibilityModelsSame = (
  a: GridColumnVisibilityModel,
  b: GridColumnVisibilityModel,
) => {
  // Filter `false` values only, as `true` and not having a key are the same
  const aFalseValues = new Set(
    Object.keys(a).filter((key) => a[key] === false),
  );
  const bFalseValues = new Set(
    Object.keys(b).filter((key) => b[key] === false),
  );
  if (aFalseValues.size !== bFalseValues.size) {
    return false;
  }

  let result = true;
  aFalseValues.forEach((key) => {
    if (!bFalseValues.has(key)) {
      result = false;
    }
  });
  return result;
};

export const defaultSearchPredicate: NonNullable<
  GridColumnsManagementProps['searchPredicate']
> = (column, searchValue) =>
  (column.headerName || column.field).toLowerCase().indexOf(searchValue) > -1;
